import React from "react";
import {useTranslation} from "react-i18next";

type UiLoaderType = {
    isOpen: boolean;
    size?: number;
    text?: string
}

export const UiLoader: React.FC<UiLoaderType> = ({
    isOpen,
    size= 30,
    text
}) => {
    const {t} = useTranslation();

    return (
        <>
            {isOpen && <div className="w-full h-full justify-center flex gap-3 items-center">
                <img
                    className="animate-spin"
                    src="/icons/loader.svg"
                    alt={t("global.loader")}
                    style={{height: size, width: size}} />

                {text !== undefined ? <p className="text-lg">{text}</p>: null}
            </div>}
        </>
    )
}
